<ng-container [formGroup]="form">
	<!-- <ion-radio-group [formControlName]="inputName" allow-empty-selection="true" (ionChange)="updateState({ event: $event, list: list, type: 'radiogroup' })">
		<ion-item *ngFor="let item of list" class="question-item">
			<ion-label class="ion-text-wrap" [ngStyle]="{ color: UtilService.getColorForAnswerChoice(item.answerChoiceAttributeColor) }">
				{{ UtilService.findObj(item.answerChoiceAttributeHeaders, 'answerChoiceAttributeHeaderLanguageId', sharedDataService.getLanguageIdForForm()).answerChoiceAttributeHeaderTitle }}
			</ion-label>
			<ion-radio mode="md" slot="start" [value]="item.answerChoiceAttributeId" ></ion-radio>
      <ion-badge slot="end" [ngStyle]="UtilService.scoreMatchAnswerColor()?{ 'background-color': UtilService.getColorForAnswerChoice(item.answerChoiceAttributeColor) }:{}" *ngIf="isShowAnswerScoreEnabled">{{item.answerChoiceAttributeScoreOrWeight}}</ion-badge>
		</ion-item>
	</ion-radio-group> -->
	<!-- <div class="question-container" [formControlName]="inputName" id="inputName" allow-empty-selection="true" (ionChange)="updateState({ event: $event, list: list, type: 'radiogroup' })"> -->
	<!-- <ion-radio-group [formControlName]="inputName" allow-empty-selection="true" (ionChange)="updateState({ event: $event, list: list, type: 'radiogroup' })"> -->
	<div class="question-container ion-radio-group">
		<div class="question-item">
			<div class="item-container" *ngFor="let item of list">
				<input
					#inputElement
					type="radio"
					mode="md"
					slot="start"
					[name]="inputName"
					[id]="item.parentAnswerChoiceQuestionAttributeId != 0 ? item.parentAnswerChoiceQuestionAttributeId : 'q_' + questionId + '_' + item.answerChoiceAttributeId"
					[value]="item.answerChoiceAttributeId"
					[formControlName]="inputName"
					(touchstart)="onSCSClick($event)"
					(click)="selectRadio($event, item.answerChoiceAttributeId)"
					class="ion-radio custom-radio-input radio-input-dark"
				/>
				<label [for]="item.parentAnswerChoiceQuestionAttributeId != 0 ? item.parentAnswerChoiceQuestionAttributeId : 'q_' + questionId + '_' + item.answerChoiceAttributeId"  class="ion-text-wrap radio-label" [ngStyle]="{ color: UtilService.getSimpleColorForAnswerChoice(item.answerChoiceAttributeColor) }">
					{{item.answerChoiceAttributeHeaders[0].answerChoiceAttributeHeaderTitle}}
				</label>
			</div>
		</div>
	</div>
	<!-- </ion-radio-group> -->
	<!-- </div> -->
</ng-container>
